import React from "react";

import style from "./two-column-layout.module.scss";
import classNames from "classnames";

interface PropTypes {
    children: JSX.Element;
    detailContentId: string;
    pageHeader: JSX.Element;
    asideContent?: JSX.Element;
    topDisclaimer?: JSX.Element;
    bottomDisclaimer?: JSX.Element;
    relatedArticles?: JSX.Element;
    footer?: JSX.Element;
    showOneColumnSeparator?: boolean;
    hideHRInSeparator?: boolean;
    reverseMobileOrder?: boolean; // Shows the asideContent before the main content on mobile
}

export const TwoColumnLayout = ({
    children,
    detailContentId,
    pageHeader,
    topDisclaimer,
    bottomDisclaimer,
    asideContent,
    relatedArticles,
    footer,
    showOneColumnSeparator = false,
    hideHRInSeparator = false,
    reverseMobileOrder = false,
}: PropTypes): JSX.Element => {
    const hasValidRelatedArticles = React.isValidElement(relatedArticles);

    return (
        <div id={detailContentId} className={style.wrapper} data-test-id={detailContentId}>
            {pageHeader}
            {topDisclaimer}
            <article className={reverseMobileOrder ? style.reverse : undefined}>
                <main className={!asideContent ? style["full-grid"] : null}>{children}</main>
                {asideContent && (
                    <>
                        {showOneColumnSeparator && (
                            <div
                                className={classNames(
                                    style["one-colum-separator"],
                                    hideHRInSeparator ? style["hide-hr"] : null,
                                )}
                            >
                                <hr />
                            </div>
                        )}
                        <aside data-test-id={`aside-${detailContentId}`}>{asideContent}</aside>
                    </>
                )}
            </article>
            {hasValidRelatedArticles && (
                <>
                    <div className={style["related"]}>
                        <div className={style["related__wrapper"]}>
                            <div className={style["related__wrapper__content"]}>{relatedArticles}</div>
                        </div>
                    </div>
                </>
            )}
            {footer && <footer>{footer}</footer>}
            {bottomDisclaimer}
        </div>
    );
};
